import { AccessGuids, ConfigSystemParams, ModalForms, ModalFormType } from "../../consts";
import { AuthenticationService } from "../../services/auth.service";
import { ClockService } from "../../services/utelize/general/clock-service";
import { CompanySelectEvent } from "../../interfaces/events/event-select-company";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ComponentAccessUserService } from "../../services/utelize/system/component-access/component-access-user-service";
import { ConfigSystemService } from "../../services/utelize/system/config-system/config-system-service";
import { environment } from "src/environments/environment";
import { ExceptionsService } from "../../services/utelize/general/exceptions-service";
import { Subscription } from "rxjs";
import { SystemUserDTO } from "../../models/system/user/system-user.dto";

@Component({
  selector: 'app-modal-comp-header',
  templateUrl: './modal-comp-header.component.html',
  styleUrls: ['./modal-comp-header.component.scss']
})

export class ModalCompHeaderComponent implements OnDestroy, OnInit {
  
  @Input() button0Danger                     : boolean       | undefined;
  @Input() button0Disabled                   : boolean       | undefined;
  @Input() button0Show                       : boolean       | undefined;
  @Input() button0Text                       : string        | undefined;
  @Input() clockEditable                     : boolean       = true;
  @Input() clockZoneKeys                     : string[]      | undefined;
  @Input() companyDropdownLabelTop           : boolean       = true;      //CRN_20260605 - false = company label sits to the left of the dropdown
  @Input() fileLockHoverText                 : string        | undefined;
  @Input() hasFeature                        : string        | undefined;
  @Input() headerActionIconClass             : string        | undefined;
  @Input() headerActionIsActive              : boolean       | undefined;
  @Input() headerActionTitle                 : string        | undefined;
  @Input() hideCompanyDropdownLabel          : boolean       = false;
  @Input() hierarchyFormatting               : boolean       | undefined;
  @Input() initialCompanyId                  : number        | undefined;
  @Input() label0Show                        : boolean       | undefined;
  @Input() label0Text                        : string        | undefined;
  @Input() microsoftIconClass                : string        | undefined;
  @Input() modalForm                         : ModalFormType | undefined;
  @Input() padlockIsLocked                   : boolean       | undefined;
  @Input() padlockLockedTitle                : string        = "Unlock User Account";
  @Input() padlockUnlockedTitle              : string        = "Lock User Account";
  @Input() showCompanyDropdown               : boolean       | undefined;
  @Input() showCompanyDropdownSelectAllOption: boolean       = true;
  @Input() showFileLockIcon                  : boolean       | undefined;
  @Input() showHeaderActionIcon              : boolean       | undefined;
  @Input() showMessageIcon                   : boolean       | undefined;
  @Input() showMicrosoftIcon                 : boolean       | undefined;
  @Input() showOpenAiIcon                    : boolean       | undefined;
  @Input() showPadlockIcon                   : boolean       | undefined;
  @Input() showClock                         : boolean       | undefined;
  @Input() showReplyIcon                     : boolean       | undefined;
  @Input() showTimelineIcon                  : boolean       | undefined;
  @Input() title                             : string        | undefined;

  @Output() button0Click             : EventEmitter<void>              =new EventEmitter<void>              ();
  @Output() cancelButtonOnClick      : EventEmitter<void>              =new EventEmitter<void>              ();
  @Output() companyDropDownChange    : EventEmitter<number>            =new EventEmitter<number>            ();
  @Output() companyDropDownChange2   : EventEmitter<CompanySelectEvent>=new EventEmitter<CompanySelectEvent>();
  @Output() fileLockButtonOnClick    : EventEmitter<void>              =new EventEmitter<void>              ();
  @Output() headerActionButtonOnClick: EventEmitter<void>              =new EventEmitter<void>              ();
  @Output() headerMouseDown          : EventEmitter<MouseEvent>        =new EventEmitter<MouseEvent>        ();
  @Output() messageButtonOnClick     : EventEmitter<void>              =new EventEmitter<void>              ();
  @Output() padlockButtonOnClick     : EventEmitter<void>              =new EventEmitter<void>              ();
  @Output() replyButtonOnClick       : EventEmitter<void>              =new EventEmitter<void>              ();
  @Output() timelineButtonOnClick    : EventEmitter<void>              =new EventEmitter<void>              ();
  
  get sureSimLogoGrow     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SureSimLogoGrow,            false) &&
                                      !this.componentAccessUserService.hasAccessGuid(AccessGuids.AnimationSureSimLogoGrowGuard, true ); }
  get titlesUseSureSimBlue() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesUseSureSimBlue,  false); }

  private barDismissedSub: Subscription | undefined;

  public clockBarDismissed   : boolean=true;
  public curUser             : SystemUserDTO;
  public isCompanyModal      : boolean=false;
  public isPlatformModeInview: boolean=environment.platformModeInview;

  constructor(
    private authenticationService     : AuthenticationService,
    private clockService              : ClockService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.isCompanyModal=this.modalForm != undefined && this.modalForm==ModalForms.Company;

      if (this.showClock) {
        this.clockService.ensureStarted(this.curUser);
        this.clockBarDismissed=this.clockService.loadBarDismissed(this.curUser);

        this.barDismissedSub=this.clockService.barDismissedChanges$
                              .subscribe(dismissed => {
                               this.clockBarDismissed=dismissed;
                             });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.barDismissedSub?.unsubscribe();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public dismissClockBar(): void {
    try {
      this.clockService.setBarDismissed(this.curUser, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public button0OnClick(): void {
    try {
      this.button0Click.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cancelButtonClick(): void {
    try {
      this.cancelButtonOnClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDropDownOnChange(companyID: number): void {
    try {
      this.companyDropDownChange.emit(companyID);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDropDownOnChange2(event: CompanySelectEvent): void {
    try {
      this.companyDropDownChange2.emit(event);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public fileLockButtonClick(): void {
    try {
      this.fileLockButtonOnClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public headerActionButtonClick(): void {
    try {
      this.headerActionButtonOnClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public headerOnMouseDown(event: MouseEvent): void {
    try {
      this.headerMouseDown.emit(event);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public messageButtonClick(): void {
    try {
      this.messageButtonOnClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public padlockButtonClick(): void {
    try {
      this.padlockButtonOnClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public replyButtonClick(): void {
    try {
      this.replyButtonOnClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public timelineButtonClick(): void {
    try {
      this.timelineButtonOnClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
